package com.partejar.app.feature.contratos.presentation

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import com.partejar.app.feature.contratos.data.ContractPdf
import kotlinx.browser.window

@Composable
actual fun rememberContractPdfHandler(): ContractPdfHandler = remember {
    ContractPdfHandler { pdf ->
        val url = pdfObjectUrl(pdf.bytes)
        val opened = window.open(url, "_blank")
        if (opened == null) window.location.assign(url)
    }
}

private fun pdfObjectUrl(bytes: ByteArray): String = js(
    """
    (() => {
        const data = new Uint8Array(bytes.length);
        for (let index = 0; index < bytes.length; index += 1) data[index] = bytes[index] & 255;
        return URL.createObjectURL(new Blob([data], { type: 'application/pdf' }));
    })()
    """
)
